import React, { useMemo } from 'react'
import { Autocomplete, FormControl, IconLabel, MenuItem, Select, TextField, createFilterOptions, useObservable } from '@cicero/ui'
import { IFormElementProps, createSyntheticChangeEvent } from '@cicero/ui/forms'
import { AttributeDoc, AttributeSchema, AttributeType, useModel } from 'models'

interface IAttributeChooserProps extends IFormElementProps<AttributeDoc|null> {
  label?: string
}

const filterAttributeValidators = createFilterOptions<AttributeDoc>()

export const AttributeChooser = ({ name, value, onChange, ...restOfProps }: IAttributeChooserProps) => {
  const Attributes = useModel(AttributeSchema)
  const options = useObservable(() => Attributes.QUERY$({ selector: {} }), [], []) // TODO Actually apply search?

  return <Autocomplete
    value={value}
    options={options}
    getOptionLabel={(v) => v.label}
    // renderOption={(o) => o.}
    selectOnFocus
    clearOnBlur
    handleHomeEndKeys
    freeSolo
    renderInput={(params) => <TextField {...restOfProps} {...params} variant="outlined" autoComplete="off" />}
    onChange={async (event, newValue) => {
      const { action } = newValue as any
      if (action) {
        const key = action.toLowerCase() // TODO Validate
        const v = await Attributes.CREATE({ label: action, key, owner_id: 'lexholden', type: AttributeType.text })
        onChange(createSyntheticChangeEvent(name, v))
      } else if (typeof newValue === 'string') {
        return
      } else {
        onChange(createSyntheticChangeEvent(name, newValue))
      }
    }}
    filterOptions={(opts, params) => {
      // LOGGER.debug({ opts, params, options })
      if (params.inputValue === '') { return opts }
      const filtered = filterAttributeValidators(opts, params)
      filtered.push({
        action: params.inputValue,
        label: `Add New Attribute "${params.inputValue}"`,
      } as any)
      return filtered
    }}
  />
}

export const AttributeTypeSelect = ({ label, ...props }: { label: string } & IFormElementProps<string>) => {
  const opts = useMemo(() => Object.entries(AttributeSchema.TYPE_CONFIG), [])

  return <FormControl>
    <Select label={label} variant="outlined" {...props}>
      { opts.map(([key, type]) => <MenuItem key={key} value={key}><IconLabel icon={type.icon} label={type.label} /></MenuItem>) }
    </Select>
  </FormControl>
}
